import { PropsWithChildren } from "react";
import { imageCaption, imageContainer } from "./styles.css";

export const Image = ({
  caption,
  accentCaption,
  children,
}: PropsWithChildren<{ caption?: string; accentCaption?: boolean }>) => {
  const captionVariant = accentCaption ? "accent" : "default";

  return (
    <div className={imageContainer}>
      {children}
      {caption && <p className={imageCaption[captionVariant]}>{caption}</p>}
    </div>
  );
};
